/**
 * Created by tiedong on 2017/8/19.
 */
import * as types from '../constants/ActionTypes'
import api from '../utils/api'


let RoleFinish = (data)=>{

    if(data.errCode==0){
        return{
            type:types.CREATE_ROLE_FINISH,
            payload:data
        }
    }else{
        return{
            type:types.CREATE_ROLE_FINISH,
            payload:{},
            error:true
        }
    }
}


let searchRoles = ()=>{
    var url = '/sysRole'
    return dispatch=>{
        dispatch({type:types.SEARCH_ROLE_START})
        return api(url).get().then(reData=>dispatch(RoleFinish(reData)))
            .catch(err=>{
                dispatch(RoleFinish({errCode:-1}))
            })
    }
}
export default {
    searchRoles
}